<template>
	<div class="product">
		<div class="relative">
			<slot></slot>

			<a class="group" :href="link">
				<int-responsive-image
					:src="image"
					:width="276"
					:ratio="1"
					mode="boxpad"
					bg-colour="FFFFFF"
					generate-crop-src
					generate-crop-src-set
					:max-width="320"
					sizes="(max-width: 767px) 276px, (max-width: 1023px) 197px, (max-width: 1279px) 206px, (max-width: 1535px) 238px, 302px"
					class="z-10 w-full border-b-[2px] border-stone-500 bg-white p-2 lg:p-4"
				>
				</int-responsive-image>

				<div class="relative w-full text-center">
					<div
						v-if="optionsCount > 1"
						class="absolute -top-9 left-2 inline-block sm:-top-14 sm:left-3"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="h-4 w-4 sm:h-5 sm:w-5"
							fill="#fff"
							stroke="#afafaf"
							stroke-width="1"
						>
							<use :href="iconHref('OptionsIcon')" />
						</svg>
					</div>

					<span
						class="mt-2 block text-base font-thin group-hover:underline lg:mt-5 lg:text-xl"
						>{{ name }}</span
					>
					<span v-if="optionsCount > 1" class="block text-xs font-thin lg:text-sm">
						{{ optionsCount }} options
					</span>

					<slot name="content" v-if="!!this.$slots.content"></slot>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
import IntResponsiveImage from "../responsive-image/"

import OptionsIcon from "../../../assets/icons/options-icon.svg"

const iconMap = {
	OptionsIcon: OptionsIcon,
}

export default {
	name: "IntProductTile",

	components: { IntResponsiveImage },

	props: {
		name: { type: String, required: true },
		image: { type: String, required: true },
		link: { type: String, required: true },
		optionsCount: { type: Number, default: 0 },
	},

	data() {
		return {
			showOptions: false,
		}
	},

	methods: {
		iconHref(key) {
			if (iconMap[key]) return "#" + iconMap[key].id
			return null
		},
	},
}
</script>
